export const Surprizebox = () => {
  return (
    <svg width="104" height="76" viewBox="0 0 104 76" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.7342 0.000286155C69.6927 -0.0605635 81.3217 9.59168 89.879 20.8133C98.2685 31.8149 96.4918 36.951 93.5379 50.548C90.5616 64.2477 80.4228 62.2758 68.1355 68.6419C55.4413 75.2188 54.2576 79.0197 41.3218 72.95C28.1642 66.7761 13.1051 73.5268 10.5638 59.0118C8.16784 45.3274 13.5603 32.0754 21.9543 21.1094C30.4969 9.94908 41.8322 0.0608896 55.7342 0.000286155Z"
        fill="#EDF3FF"
        fillOpacity="0.6"
      />
      <path
        d="M50.9922 75.998L32.8527 62.5541L22.9922 40.998L39.9922 51.998L50.9922 75.998Z"
        fill="#B8CEFA"
        fillOpacity="0.6"
      />
      <path
        d="M50.9922 75.998L95.9922 50.998L85.9922 26.998L39.9922 51.998L50.9922 75.998Z"
        fill="#B8CEFA"
      />
      <path
        d="M85.9922 26.998L39.9922 51.998L22.9922 40.998L66.9922 17.998L85.9922 26.998Z"
        fill="#99BCFF"
      />
      <path
        d="M73.3922 20.998L76.4922 22.4569L31.992 46.798L42.4917 69.6981L39.6917 67.6981L29.1914 44.998L73.3922 20.998Z"
        fill="#EDF3FF"
      />
      <path
        d="M43.4245 28.8488C43.7411 28.1965 44.5304 27.9225 45.1881 28.2365L65.8759 38.498L76.9917 61.598L73.9917 63.218L63.4985 39.8888L44.0419 30.5978C43.3843 30.2838 43.1079 29.501 43.4245 28.8488Z"
        fill="#EDF3FF"
      />
      <path
        d="M49.105 29.0345C51.7617 27.5619 52.5045 23.8228 50.7641 20.683C49.0237 17.5433 45.4592 16.1918 42.8025 17.6645C40.1457 19.1371 39.4029 22.8762 41.1433 26.0159C42.8837 29.1557 46.4483 30.5072 49.105 29.0345Z"
        fill="#B8CEFA"
      />
      <path
        d="M48.9921 29.8074C48.837 28.9642 42.1887 24.823 37.7307 26.3221C33.2726 27.8212 35.5985 34.998 35.5985 34.998L48.7982 33.4989L48.9921 29.8074Z"
        fill="#EDF3FF"
      />
      <path
        d="M37.7307 26.3221C42.1887 24.823 48.837 28.9642 48.9921 29.8074L48.7982 33.4989L35.5985 34.998C35.5949 34.9867 33.3483 28.0425 37.5263 26.3963L37.7307 26.3221ZM44.5829 28.1063C42.4017 27.1775 39.9176 26.6414 38.0497 27.2694C36.4815 27.7967 35.97 29.3227 35.9931 31.2099C36.0041 32.1129 36.1431 32.9874 36.2831 33.6445C36.3028 33.737 36.3235 33.8247 36.3427 33.9072L47.8436 32.5995L47.9745 30.0956C47.9714 30.0927 47.9689 30.0888 47.9657 30.0858C47.8106 29.9415 47.5648 29.7485 47.2333 29.5243C46.5742 29.0786 45.646 28.559 44.5829 28.1063Z"
        fill="#B8CEFA"
      />
      <path
        d="M49.3415 28.1565C48.6846 27.5619 48.6073 19.7547 52.2783 16.8198C55.9493 13.8849 60.9921 19.7547 60.9921 19.7547L52.6647 29.998L49.3415 28.1565Z"
        fill="#EDF3FF"
      />
      <path
        d="M52.2783 16.8198C55.9493 13.8849 60.9921 19.7547 60.9921 19.7547L52.6647 29.998L49.3415 28.1565C48.6846 27.5619 48.6073 19.7547 52.2783 16.8198ZM57.4725 18.0293C55.8171 16.9697 54.1934 16.5694 52.9032 17.6006C51.3738 18.8233 50.5235 21.185 50.1757 23.5137C50.0062 24.648 49.9668 25.7054 50.0057 26.498C50.0253 26.8967 50.0638 27.206 50.1073 27.414C50.1093 27.4236 50.1122 27.4326 50.1141 27.4414L52.4159 28.7168L59.66 19.8066C59.5966 19.744 59.5303 19.6763 59.4579 19.6074C58.9559 19.1298 58.261 18.5339 57.4725 18.0293Z"
        fill="#B8CEFA"
      />
      <path
        d="M50.2302 32.4842C49.4659 31.6209 38.4678 31.0754 34.0646 35.6656C32.9687 36.8126 32.6266 38.0878 32.7257 39.3826C33.1229 43.9172 38.822 46.1442 42.8388 43.4421L52.5666 36.8912L50.2302 32.4842Z"
        fill="#B8CEFA"
      />
      <path
        d="M52.0388 31.2076C51.509 30.2016 55.5315 20.8962 61.7909 19.2076C63.3607 18.7765 64.7343 19.0459 65.9312 19.6927C70.15 21.9382 69.9538 27.6148 65.6761 29.7705L55.3157 34.998L52.0388 31.2076Z"
        fill="#B8CEFA"
      />
      <path
        d="M55.6966 36.1837C57.5436 34.5207 57.3931 31.3427 55.3606 29.0853C53.3281 26.828 50.1831 26.3461 48.3362 28.0091C46.4893 29.6721 46.6398 32.8502 48.6723 35.1075C50.7048 37.3649 53.8497 37.8467 55.6966 36.1837Z"
        fill="#EDF3FF"
      />
      <path
        d="M54.6174 29.7545C52.8226 27.7612 50.3094 27.5781 49.0053 28.7523C47.7014 29.9265 47.6207 32.4451 49.4154 34.4384C51.2102 36.4317 53.7234 36.6147 55.0275 35.4406L55.6966 36.1837C53.8497 37.8467 50.7048 37.3649 48.6723 35.1075C46.6398 32.8502 46.4893 29.6721 48.3362 28.0091C50.1831 26.3461 53.3281 26.828 55.3606 29.0853C57.3931 31.3427 57.5436 34.5207 55.6966 36.1837L55.0275 35.4406C56.3316 34.2664 56.4123 31.7478 54.6174 29.7545Z"
        fill="#B8CEFA"
      />
      <path
        d="M25.9925 4.998C27.0971 4.998 27.9969 4.10258 28.0023 2.99802C28.0078 1.89347 27.1167 0.998047 26.0122 0.998047C24.9076 0.998047 24.0078 1.89347 24.0023 2.99802C23.9969 4.10258 24.8879 4.998 25.9925 4.998Z"
        fill="#F4F8FF"
      />
      <path
        d="M92.9923 16.998C94.0969 16.998 94.9967 16.1026 95.0021 14.998C95.0076 13.8935 94.1166 12.998 93.012 12.998C91.9074 12.998 91.0076 13.8935 91.0021 14.998C90.9967 16.1026 91.8877 16.998 92.9923 16.998Z"
        fill="#F4F8FF"
      />
      <path
        d="M57.4927 12.998C58.3211 12.998 58.996 12.3264 59.0001 11.498C59.0042 10.6696 58.3359 9.99805 57.5075 9.99805C56.679 9.99805 56.0042 10.6696 56.0001 11.498C55.996 12.3264 56.6643 12.998 57.4927 12.998Z"
        fill="white"
      />
      <path
        d="M46.9927 7.99802C47.545 7.99802 47.9949 7.55031 47.9976 6.99803C48.0003 6.44576 47.5548 5.99805 47.0025 5.99805C46.4503 5.99805 46.0003 6.44576 45.9976 6.99803C45.9949 7.55031 46.4404 7.99802 46.9927 7.99802Z"
        fill="white"
      />
      <path
        d="M96.9926 7.99802C97.5448 7.99802 97.9948 7.55031 97.9975 6.99803C98.0002 6.44576 97.5547 5.99805 97.0024 5.99805C96.4501 5.99805 96.0002 6.44576 95.9975 6.99803C95.9948 7.55031 96.4403 7.99802 96.9926 7.99802Z"
        fill="#F4F8FF"
      />
      <path
        d="M28.4925 23.998C29.3209 23.998 29.9958 23.3264 29.9999 22.498C30.004 21.6696 29.3357 20.998 28.5073 20.998C27.6789 20.998 27.004 21.6696 26.9999 22.498C26.9958 23.3264 27.6641 23.998 28.4925 23.998Z"
        fill="white"
      />
      <path
        d="M102.493 34C103.321 34 103.996 33.3284 104 32.5C104.004 31.6716 103.336 31 102.507 31C101.679 31 101.004 31.6716 101 32.5C100.996 33.3284 101.664 34 102.493 34Z"
        fill="white"
      />
      <path
        d="M1.49263 63C2.32106 63 2.99594 62.3284 3.00002 61.5C3.00409 60.6716 2.33582 60 1.50739 60C0.678966 60 0.00409491 60.6716 1.85504e-05 61.5C-0.00405781 62.3284 0.664204 63 1.49263 63Z"
        fill="white"
      />
      <path
        d="M19.2127 44.9928L18.2194 42.9095L19.877 41.3024L17.5797 41.6013L16.5588 39.5457L16.126 41.8075L13.8345 42.145L15.8557 43.2418L15.4784 45.5034L17.1639 43.9237L19.2127 44.9928Z"
        fill="#B8CEFA"
      />
      <path
        d="M75.2906 10.7784L77.5855 10.533L78.5512 12.6301L79.0319 10.3639L81.3098 10.0832L79.3199 8.92416L79.7623 6.65057L78.0567 8.193L76.0486 7.08644L76.9792 9.20077L75.2906 10.7784Z"
        fill="#B8CEFA"
      />
      <path
        d="M1.01302 52.6376L2.6015 54.312L1.52168 56.3526L3.61413 55.3585L5.22033 56.998L4.933 54.7131L7.00805 53.6841L4.74688 53.2655L4.40678 50.998L3.29192 53.0213L1.01302 52.6376Z"
        fill="#B8CEFA"
      />
      <path
        d="M14.2788 13.7416L16.5762 13.5207L17.5195 15.628L18.0243 13.3671L20.3052 13.1107L18.3278 11.9305L18.7944 9.66174L17.0724 11.1859L15.0763 10.0579L15.9842 12.1821L14.2788 13.7416Z"
        fill="#B8CEFA"
      />
      <path
        d="M96.013 23.6376L97.6015 25.312L96.5217 27.3526L98.6141 26.3585L100.22 27.998L99.933 25.7131L102.008 24.6841L99.7469 24.2655L99.4068 21.998L98.2919 24.0213L96.013 23.6376Z"
        fill="#B8CEFA"
      />
      <path
        d="M8.99151 30.998C10.0961 30.998 10.9959 30.1026 11.0014 28.998C11.0068 27.8935 10.1158 26.998 9.01119 26.998C7.90662 26.998 7.00679 27.8935 7.00135 28.998C6.99592 30.1026 7.88694 30.998 8.99151 30.998Z"
        fill="#F4F8FF"
      />
      <path
        d="M73.4921 4.99801C74.3205 4.99801 74.9954 4.32644 74.9995 3.49803C75.0036 2.66961 74.3353 1.99805 73.5069 1.99805C72.6784 1.99805 72.0036 2.66961 71.9995 3.49803C71.9954 4.32644 72.6637 4.99801 73.4921 4.99801Z"
        fill="#F4F8FF"
      />
    </svg>
  );
};
